RivalIQ.module('data', function (data, App, Backbone, Marionette, $, _) {

    'use strict';

    const PrivateMetadata = RivalIQ.data.CacheLayer.extend({
        name: 'Private Metadata',
        cacheKeys: [
            'landscapeId',
            'channel'
        ],

        loadData: function (attrs) {
            const url = [
                '/api/landscapes/',
                attrs.landscapeId,
                '/channels/',
                attrs.channel,
                '/privateMetadata'
            ].join('');
            return $.get(url).then(function (data) {
                return data;
            });
        }
    });

    data.privateMetadata = new PrivateMetadata();
});
